define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"ProductSpec/SizeChart/CustomViewSizeChartOptions",
	"ProductSpec/SizeChart/SizeChartTableCustomViewOptionsStore",
	"ProductSpec/SizeChart/SizeChartTableOptionsTab",
	"SiteAdmin/DataSheetTablePreferences",
	"../SizeChart",
	"./_SizeChartTableMixin",
	"./Table"
], function(declare, _, {SizeChartDimensionFormatType}, SizeChartTableCustomViewOptionsStore, SizeChartTableOptionsTab, DataSheetTablePreferences, SizeChart, _SizeChartTableMixin, Table) {

	var _Preferences = declare(DataSheetTablePreferences, {
		constructor: function() {
			this.addCustomOption("sizeChartUnits", SizeChart.valueUnits, false, "SizeChartUnits");
			this.addCustomOption("sizeChartDimensionFormat", SizeChartDimensionFormatType.DEFAULT, false, "SizeChartDimensionFormat");
			this.addCustomOption("sizeChartHighlightBlankTolerance", true, false, "SizeChartHighlightBlankTolerance");
			this.addCustomOption("sizeChartHighlightActualOutOfTolerance", true, false, "SizeChartHighlightActualOutOfTolerance");
			this.addCustomOption("sizeChartHighlightDeltaOutOfTolerance", true, false, "SizeChartHighlightDeltaOutOfTolerance");
			this.addCustomOption("sizeChartHighlightRevisedDeltaOutOfTolerance", true, false);
		}
	});

	return declare([Table, _SizeChartTableMixin], {
		prefClass: _Preferences,

		customViewOptionsComponent: SizeChartTableOptionsTab,
		customViewOptionsStore: SizeChartTableCustomViewOptionsStore,

		// Boolean: hide old review comments if not on current revision
		//bHideOldComments: false,

		// String[]: list of urls to display as columns; if empty, then show all
		//columnNodeUrls: null,

		// String[]: list of reviews to compare against
		//reviewUrls: null,

		getActiveSizes: function() {
			// summary: return sizes currently displayed as columns (only valid in Evaluation view, not Evaluation By Sample)
			var revision = this.getViewNode();
			var urls = this.columnNodeUrls;

			if (revision && _.isEmpty(urls)) {
				var review = this.cacheView.getNode(revision.Review);
				urls = review.ReviewSizes;
			}

			return this.cacheView.getNodes(urls);
		},

		getPrintProperties: function() {
			// summary: return object containing properties from view necessary to recreate it for printing that are not custom view options
			var params = this.inherited(arguments);
			params.columnNodeUrls = this.columnNodeUrls;
			params.reviewUrls = this.reviewUrls;
			return params;
		},

		postCreate: function() {
			// summary: reset selected reviews when sizes change
			var self = this;

			this.inherited(arguments);

			this.watch("columnNodeUrls", function(name, oldValue, newValue) {
				self.set("reviewUrls", null);
			});
		},

		onViewStartBuild: function() {
			// summary: if size not yet set, then default to first size; if multiple sizes being reviewed, this should already be initialized to "centric:"
			this.resetSubSizeRangeData();
			this.resetSizeChartRevisionData();
		},

		_onRootDependencyPaths: function(/*String[]*/paths) {
			// summary: add paths for sizes and size ranges
			paths.push("Child:__Parent__;Sizes;SizeChartSubSizeRanges");
			paths.push("Child:Review/Child:ReviewSizes");
			this.inherited(arguments);
		},

		_resolveView: function() {
			// summary: only show previous review comments if viewing current revision
			var node = this.getViewNode();
			this.bHideOldComments = node && !node.IsCurrent;
			this.inherited(arguments);
		},

		/**
		 * Return the samples of sizes
		 * @param {string[]} [values] - array of size urls
		 * @return {string[]} - sample URLs
		 */
		_getSampleUrlsFromSelectedSizes: function(values) {
			var sampleUrls = [];
			var sizeUrls = values || this.columnNodeUrls;
			var sizes = this.cacheView.getNodes(sizeUrls);
			if (sizes.length) {
				// extract samples from size
				_.each(sizes, function(size) {
					sampleUrls = sampleUrls.concat(size.ReviewSizeSamples);
				});
			}
			return sampleUrls;
		},

		/**
		 * Set the columnNodeUrls value when it changes and also update columnNodeSampleUrls ( use case for EvaluationBySample view)
		 * @param {string[]} values - selected size urls
		 */
		_setColumnNodeUrlsAttr: function(values) {
			var samples;
			if (values) {
				samples = this._getSampleUrlsFromSelectedSizes(values);
			}
			this.set("columnNodeSampleUrls", samples);
			this._set("columnNodeUrls", values);
		}
	});
});